import { IBusinessCategory } from "@/@Interfaces/BusinessCategory";

export const BusinessCategory: IBusinessCategory[] = [
  { value: "Music", label: "Music" },
  { value: "Sports", label: "Sports" },
  { value: "Fashion", label: "Fashion" },
  { value: "Beauty & Wellness", label: "Beauty & Wellness" },
  { value: "Arts & Culture", label: "Arts & Culture" },
];
